import Drawer from '@material-ui/core/Drawer';
import styled from 'styled-components';

export const DrawerHeader = styled.div`
	display: flex;
	flex-direction: column;
	padding: 24px 16px;
	text-align: left;
`;

export const NavigationDrawer = styled(Drawer)`
	display: block;
	flex-shrink: 0;
	min-width: 300px;
`;

export const DrawerContent = styled.div`
	min-width: 300px;
`;
